import React from "react";
import styled from "styled-components";
import { MixStyle } from "../../../../styles";
import { LeftContainer } from "./LeftContainer";
import Right from "./RightContainer";
const StyledNavbar = styled.nav`
  ${MixStyle.flexArround}
  flex-wrap: wrap;
  min-height: 66px;
  padding: 0px 20px;
`;

export const TopNav = () => {
  return (
    <StyledNavbar>
      <LeftContainer />
      <Right />
    </StyledNavbar>
  );
};
